import React from 'react';

interface ChatHeaderProps {
  title: string;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ title }) => (
  <div className="flex-shrink-0 px-4 py-3 border-b border-border bg-[var(--surface-sidebar-right)]">
    <div className="w-full max-w-[720px] mx-auto md:mx-0 md:px-4">
      <h1 className="text-lg font-semibold text-foreground truncate">
        {title || 'New conversation'}
      </h1>
    </div>
  </div>
);

